export const routePath = {
  home: '/index',
  intro: '/intro',
  commonProblem: '/commonProblem',
  detail: '/commonProblem/detail',
  versionInfo: '/versionInfo',
  contactUs: '/contactUs',
  productDownload: '/productDownload',
  itPro: '/itPro',
  scpController: '/scpcontroller',
}
